import ThumbnailNoImage from './ThumbnailNoImage';
export default ThumbnailNoImage;
